import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisFacilityActivityQuery = (
  campaignId: string,
  facilityId: string,
  platformId?: string,
  range?: ReviewAnalysisDateRange,
  venueName?: string
) =>
  useQuery({
    enabled: !!campaignId && !!facilityId,
    queryFn: () =>
      ReviewAnalysisApiService.getFacilityActivity(
        campaignId,
        facilityId,
        platformId,
        range,
        venueName
      ),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_FACILITY_ACTIVITY,
      campaignId,
      facilityId,
      platformId,
      range?.from ?? '',
      range?.to ?? '',
      venueName ?? '',
    ],
  })
